<template>
    <div>
        <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" style="display: none" />
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
    mounted () {
        console.log('ImageMenu')
        this.$refs.fileInput.click();
    },

    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                EventBus.$emit('postcreator/uploadFile',(fileAdded)=>{
                    this.$emit('addSticker','image', {
                        data: {
                            idFile: fileAdded.id
                        }
                    })
                },file)
            }
        }
    }
}
</script>
